module.exports = __webpack_public_path__ + "static/avatar-e09c987b7dec43adfd89e1518192ecfb.jpg";